import { SAMConfig, SOMConfig } from "../../types/workspace";
export const BACCHUS_API_URL = "/bacchus-api/api";
export const DEFAULT_SAM: SAMConfig = {
  industry: {
    ids: [],
    sicIds: [],
    naicsIds: [],
    excludedIds: [],
    excludedSicIds: [],
    excludedNaicsIds: [],
  },
  geography: {
    regionsIds: [],
    countryIds: [],
    stateIds: [],
    excludedCountryIds: [],
  },
};

export const DEFAULT_SOM: SOMConfig = {
  employeeRange: { min: undefined, max: undefined },
  revenueRange: { min: undefined, max: undefined },
  productIds: [],
  excludedProductIds: [],
  productsInclusionMethod: "ANY_PRESENT",
  excludedProductsInclusionMethod: "NONE_PRESENT",
};
